import { queryOptions } from '@tanstack/react-query';

import { fetchStandings } from '@apis/standings';

export const getStandingsQuery = (params: Parameters<typeof fetchStandings>[0]) =>
  queryOptions({
    queryKey: ['standings', params],
    queryFn: ({ signal }) => fetchStandings(params, signal),
    placeholderData: [],
  });
